// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__IFcDD","perdeu":"LoginForm_perdeu__Z+ks1","cadastro":"LoginForm_cadastro__zLu93","subTitle":"LoginForm_subTitle__glGxB"};